import {
  SET_USER,
  UPDATE_USER,
  UPDATE_LANGUAGE
} from "../constants/actionTypes";

export const setUser = user => ({
  type: SET_USER,
  payload: user
});

export const updateUser = user => ({
  type: UPDATE_USER,
  payload: user
});

export const updateLanguage = (language, languageId) => ({
  type: UPDATE_LANGUAGE,
  payload: {
    language,
    languageId
  }
});
